<template>
  <div class="page">
    <p class="page_title">404 {{ $t('m.page_not_found') }}</p>
    <el-button type="primary" round @click="$router.replace({ path: '/' })">返回首页</el-button>
  </div>
</template>

<script>

export default {
  name: '404'
}
</script>

<style lang="scss" scoped>
  .page {
    background: #303133;
    background-blend-mode: multiply,multiply;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .page_title {
      font-size: 20px;
      color: #FFF;
      margin-bottom: 5vh;
    }
  }
</style>
